import { useState } from "react";
import { api } from "@/lib/api";
import { InjectableTextarea } from "@/components/InjectableTextarea";
import { Button } from "@/components/ui/button";
import { Mic2, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const NarrationEditor = ({ project, sceneIndex, narration, onSaved }) => {
  const [text, setText] = useState(narration);
  const [saving, setSaving] = useState(false);
  const changed = text.trim() !== narration.trim();

  const save = async () => {
    setSaving(true);
    try {
      await api.updateScene(project.id, sceneIndex, { narration: text.trim() });
      toast.success(`Scene ${sceneIndex + 1} voiceover re-recorded`);
      await onSaved();
    } catch {
      toast.error("Couldn't re-record the voiceover. Please try again.");
    }
    setSaving(false);
  };

  return (
    <div className="mt-5 pt-4 border-t border-white/10">
      <div className="flex items-center justify-between mb-2 gap-3">
        <div className="text-sm font-semibold flex items-center gap-1.5"><Mic2 className="h-4 w-4 text-[#22C55E]" /> Voiceover narration</div>
        <Button data-testid="save-narration-btn" onClick={save} disabled={!changed || !text.trim() || saving} size="sm"
          className="bg-[#22C55E] hover:bg-[#16A34A] text-[#0F1117] font-semibold rounded-full disabled:opacity-40">
          {saving ? <><Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> Recording…</> : "Save & hear new voice"}
        </Button>
      </div>
      <InjectableTextarea
        data-testid="narration-editor"
        value={text}
        onValueChange={setText}
        className="min-h-[80px] bg-[#0F1117]/70 border-white/10 text-sm resize-none font-serif-i"
      />
    </div>
  );
};
